import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function SelectBox({ label, list, selectedValue, onChange,fetchKey }) {
  return (
    <FormControl sx={{ m: 1, width: "200px" }} size="small">
      <InputLabel id={`select-${label}`}>{label}</InputLabel>
      <Select
        labelId={`select-${label}`}
        id={`select-${label}`}
        value={selectedValue}
        onChange={onChange}
        label={label}
      >
        {list?.length > 0 && <MenuItem value={null}>All</MenuItem>}{" "}
        {/* Handle the 'All' selection */}
        {list?.length > 0 ? (
          list.map((item) => (
            <MenuItem key={item[fetchKey]} value={item[fetchKey]}>
              {item.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem key="nodata" disabled>
            No {label} Available
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
}

export default SelectBox;
